import { render, staticRenderFns } from "./PgsqlDatabase.vue?vue&type=template&id=7cf0d642&"
import script from "./PgsqlDatabase.vue?vue&type=script&lang=js&"
export * from "./PgsqlDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf0d642')) {
      api.createRecord('7cf0d642', component.options)
    } else {
      api.reload('7cf0d642', component.options)
    }
    module.hot.accept("./PgsqlDatabase.vue?vue&type=template&id=7cf0d642&", function () {
      api.rerender('7cf0d642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/database/PgsqlDatabase.vue"
export default component.exports